export enum GlobalSearchType {
    All = 0,
    Courses = 1,
    Webinars = 2,
    TaxAMinutes = 3,
    Articles = 4,
    QuickGuides = 5,
}

export enum GlobalSearchSortType {
    MostRelevant = 0,
    LatestPublished = 1,
}
